import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const numberMoreThan0Message = () => i18n.t("validation.numberGreaterThanZero", {ns: "common"});

export const queueOptionsValidation = yup.object().shape({
    options: yup.object().shape({
        queue: yup.object().shape({
            isActive: yup.boolean(),
            maxCount: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            maxWaitingTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            thresholdCount: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            }),
            thresholdTime: yup.number().when("isActive", {
                is: true,
                then: yup
                    .number()
                    .required(requiredMessage)
                    .positive(numberMoreThan0Message)
                    .integer()
            })
        })
    })
});
